const initialState = {
  meetingList: [],
  meetingListFirst: [],
  selectedMeeting: { officialReport: { participants: [] } },
  isOpenOfficialReport: true,
};

const meetingManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_MEETING_LIST": {
      const meetingList = action.payload;
      return {
        ...state,
        meetingList: meetingList.slice().sort((a, b) => {
          return a.id > b.id ? 1 : -1;
        }),
      };
    }
    case "FETCH_MEETING_LIST_FIRST": {
      const meetingListFirst = action.payload;
      return {
        ...state,
        meetingListFirst: meetingListFirst.slice().sort((a, b) => {
          return a.id > b.id ? 1 : -1;
        }),
      };
    }
    case "FETCH_MEETING": {
      return { ...state, selectedMeeting: action.payload };
    }
    case "EDIT_FETCHED_MEETING": {
      return { ...state, selectedMeeting: action.payload };
    }
    case "CREATE_NEW_MEETING": {
      const newMeeting = action.payload;
      return {
        ...state,
        meetingList: state.meetingList
          .concat(newMeeting)
          .slice()
          .sort((a, b) => {
            return a.id > b.id ? 1 : -1;
          }),
        newMeeting: newMeeting,
      };
    }
    case "EDIT_MEETING": {
      let meetingListWithoutEdited = state.meetingList.filter(
        (m) => m.id !== action.payload.id
      );
      return {
        ...state,
        meetingList: [...meetingListWithoutEdited, action.payload]
          .slice()
          .sort((a, b) => {
            return a.id > b.id ? 1 : -1;
          }),
      };
    }
    case "DELETE_MEETING": {
      return {
        ...state,
        meetingList: state.meetingList.filter(
          (m) => m.id !== action.payload[0]
        ),
      };
    }
    case "SET_OPEN_OFFICIAL_REPORT": {
      return { ...state, isOpenOfficialReport: action.payload };
    }
    default:
      return state;
  }
};

export default meetingManagement;
